import { GridColDef, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';
export const ObjectNameIsEqualTo: GridFilterOperator = {
  label: 'ObjectNameIsEqualTo',
  value: 'ObjectNameIsEqualTo',

  getApplyFilterFn: (filterItem: GridFilterItem, column: GridColDef) => {

    return (params: any): boolean => {
      return params.value?.name === filterItem.value;
    };
  },
};